var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"prz-blk-content-elem",class:_vm.contentClass,style:(_vm.contentStyle)},[(_vm.content.icon)?_c('i',{class:_vm.content.icon}):_vm._e(),(_vm.content.text)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.content.text)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }